// The product section is rendered twice: once inline and once inside the sticky
// floated form. Each copy has its own variant picker and its own add to cart
// form, and the theme never syncs them, so an option chosen in one copy is
// missing from the other and the wrong variant gets ordered.
if (!window.variantPickerSync) {
  window.variantPickerSync = true;

  // Pairs a picker with its copies. FloatedForm rewrites the section id and keeps
  // the original one in data-original-section, so both point at the same section.
  const sectionKey = (picker) => picker.dataset.originalSection || picker.dataset.section;

  // The dropdown picker keeps its own label, which only the theme's click handler
  // updates. Programmatic selection has to update it too.
  const updateDropdownLabel = (radio) => {
    const dropdown = radio.closest('.dropdown-select');
    const label = dropdown && dropdown.querySelector('.select-label span');
    if (!label) return;

    label.textContent = radio.value;
    label.setAttribute('title', radio.value);
  };

  let syncing = false;

  document.addEventListener('change', (event) => {
    if (syncing) return;

    const radio = event.target;
    if (!radio.matches || !radio.matches('input[type="radio"]')) return;

    const picker = radio.closest('variant-radios');
    if (!picker) return;

    // Options are matched by position rather than by name, because the floated
    // copy rewrites the section id that some picker styles put in the radio name.
    const fieldsets = Array.from(picker.querySelectorAll('fieldset'));
    const index = fieldsets.findIndex((fieldset) => fieldset.contains(radio));
    if (index === -1) return;

    syncing = true;

    document.querySelectorAll('variant-radios').forEach((twin) => {
      if (twin === picker || sectionKey(twin) !== sectionKey(picker)) return;

      const fieldset = twin.querySelectorAll('fieldset')[index];
      if (!fieldset) return;

      const target = Array.from(fieldset.querySelectorAll('input[type="radio"]')).find(
        (input) => input.value === radio.value
      );
      if (!target || target.checked) return;

      target.checked = true;
      target.dispatchEvent(new Event('change', { bubbles: true }));
      updateDropdownLabel(target);
    });

    syncing = false;
  });
}
